export default __webpack_public_path__ + "static/media/user-profile-bg.2b7a89db.png";